import addDefaultEventListener from './add-default-event-listener';

function querySelectorAll(container, selector) {
  let nodeList = container.querySelectorAll(selector);
  return Array.prototype.slice.call(nodeList);
}

function createFocusManager() {
  let isAdjustingFocus = false;
  let next = null;

  function addContainer(container, priority) {
    removeContainer(container);

    const root = { next };
    let c = root;
    while (c.next && priority <= c.next.priority) {
      c = c.next;
    }

    c.next = {
      container: container,
      priority: priority,
      next: c.next,
    };

    next = root.next;

    if (next) {
      ensureFocusIsValid();
    }
  }

  function getTopPriority() {
    return next ? next.priority : 0;
  }

  function removeContainer(container) {
    const root = { next };
    let c = root;
    while (c.next) {
      if (c.next.container === container) {
        c.next = c.next.next;
      } else {
        c = c.next;
      }
    }

    next = root.next;

    if (next) {
      ensureFocusIsValid();
    }
  }

  function handleDocumentKeyDown(e) {
    if (e.defaultPrevented) {
      return;
    }

    let keyCode = e.which || e.keyCode;
    if (keyCode === 9) {
      moveFocus(e.shiftKey ? -1 : 1);
      e.preventDefault();
    }
  }

  function handleDocumentFocusIn() {
    if (isAdjustingFocus) {
      return;
    }

    ensureFocusIsValid();
  }

  function ensureFocusIsValid() {
    let currentFocus = document.activeElement;

    if (currentFocus && !focusIsValid(currentFocus)) {
      moveFocus(1);
      //Or maybe remove focus
      //currentFocus.blur();
    }
  }

  function elementIsVisible(element) {
    return !!(
      element.offsetWidth ||
      element.offsetHeight ||
      element.getClientRects().length
    );
  }

  function focusIsValid(element) {
    if (element.getAttribute('disabled')) {
      return false;
    }

    if (next && !next.container.contains(element)) {
      // Permitir elementos do Bryntum DatePicker
      if (
        element.closest('.b-datepicker') ||
        element.closest('.b-calendar') ||
        element.closest('.b-popup') ||
        element.closest('.b-floating')
      ) {
        return true;
      }
      return false;
    }

    if (element.classList.contains('datePicker')) {
      return false;
    }

    return true;
  }

  function moveFocus(increment) {
    if (isAdjustingFocus) {
      return;
    }

    isAdjustingFocus = true;

    let focusables = querySelectorAll(
      (next && next.container) || document,
      'a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabIndex], *[contenteditable]'
    )
      .filter(elementIsVisible)
      .filter((e) => e.getAttribute('tabIndex') != '-1');

    let currentFocus = document.activeElement;
    let numFocusables = focusables.length;
    let currentIndex = focusables.indexOf(currentFocus);
    let index = currentIndex;
    let nextFocus = null;

    for (let i = 0; i < numFocusables; i++) {
      index += increment;

      if (index < 0) {
        index = numFocusables - 1;
      } else if (index > numFocusables - 1) {
        index = 0;
      }

      let element = focusables[index];

      if (focusIsValid(element)) {
        nextFocus = element;
        break;
      }
    }

    if (nextFocus !== currentFocus) {
      if (nextFocus) focusWithoutScrolling(nextFocus);
      else currentFocus.blur();
    }

    isAdjustingFocus = false;
  }

  function focusWithoutScrolling(el) {
    let scrollHierarchy = [];

    let parent = el.parentNode;
    while (parent) {
      scrollHierarchy.push([parent, parent.scrollLeft, parent.scrollTop]);
      parent = parent.parentNode;
    }

    el.focus();

    scrollHierarchy.forEach(function (item) {
      let el = item[0];

      if (el.scrollLeft != item[1]) el.scrollLeft = item[1];

      if (el.scrollTop != item[2]) el.scrollTop = item[2];
    });
  }

  const focusManager = {
    addContainer,
    getTopPriority,
    removeContainer,
    handleDocumentKeyDown,
    handleDocumentFocusIn,
    ensureFocusIsValid,
    elementIsVisible,
    focusIsValid,
    moveFocus,
    focusWithoutScrolling,
  };

  addDefaultEventListener('keydown', (e) =>
    focusManager.handleDocumentKeyDown(e)
  );
  addDefaultEventListener('focusin', () =>
    focusManager.handleDocumentFocusIn()
  );

  return focusManager;
}

export default createFocusManager();
